import step1 from "@/assets/integration-steps/meta/step_1.png";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
interface Props {
  stepLabel?: string;
}

const MetaIntegrationStep1 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step meta-step-1">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Meta Pixel</h6>
    </div>
    <div className="wrapper">
      <p>
        The Meta Pixel is the piece of code that allows Meta Ads to track events
        or add users to Audiences.
      </p>
      <p>
        Opticks uses these Audiences to exclude invalid traffic, so the first
        step is to{" "}
        <b>
          make sure that both OpticksJs and your Meta Pixel are properly
          installed
        </b>{" "}
        in the page you want to protect.{" "}
      </p>
      <p>
        You can check your Meta Pixels in the Data Sources section under Events
        Manager.
      </p>
      <p>
        The absence of the Meta Pixel does not affect data collection or
        detection, as observed in Analytics. The source of traffic from Facebook
        is identified through other means, such as our custom script, and
        potentially through UTM parameters or the presence of a Facebook ID.
      </p>
      <p>
        However, the{" "}
        <b>
          absence of the Pixel hinders our ability to provide effective
          prevention
        </b>{" "}
        measures on the Meta platforms.
      </p>
    </div>
    <img src={step1} alt="Screenshot of step 1 Meta Integration" />
  </div>
);

export default MetaIntegrationStep1;
